import { useState} from 'react';
import Media from 'react-media';

import Body2 from 'components/Body2';


import {
    ENROLL_BANNER_MOBILE,
    ENROLL_BANNER_WEB
} from 'utilities/sessionStorageKeys';

import { mobileWidth, tabletWidth } from './breakpoints.module.scss';

import styles from './styles.module.scss';

import { set, get } from 'temp/utilities/sessionStorage';

const PlanEnrollBanner = () => {
    const [open, setOpen] = useState(true);
    const [mopen, setMOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    const view = (
        <div
            className={styles.planEnrollContainer} 
        >
            <div
                className={styles.closeIconBlock}
                onClick={() => {
                    if (isMobile) {
                        setMOpen(false);
                        set(ENROLL_BANNER_MOBILE, 'true');
                    } else {
                        setOpen(false);
                        set(ENROLL_BANNER_WEB, 'true');
                    }
                }}
            />
            <div className={styles.planEnrollContent}>
                <div className={styles.tick}>
                    <Body2
                        className={styles.contentArea}
                        text="We are now PlanEnroll – new name, same dedication to
                            Medicare guidance."
                    />
                </div>
            </div>
        </div>
    );

    const webView = !get(ENROLL_BANNER_WEB) && view;
    const mobileView = !get(ENROLL_BANNER_MOBILE) && view;

    if (!open && !mopen) return <></>;

    return (
        <>
            <Media
                queries={{
                    mobile: { maxWidth: mobileWidth },
                    tablet: {
                        minWidth: parseInt(mobileWidth, 10) + 1,
                        maxWidth: tabletWidth
                    }
                }}
                onChange={breakpoint => {
                    setIsMobile(breakpoint.mobile);
                }}
            />
            {isMobile ? mobileView : webView}
        </>
    );
};

export default PlanEnrollBanner;
